import classnames from "classnames"
import styles from "./Modal.module.scss"
import { Close } from "../../svgs/Close"
import { CSSProperties, MouseEventHandler, ReactNode } from "react"

interface ModalProps {
  isOpen: boolean
  closeModal: MouseEventHandler<HTMLDivElement | HTMLButtonElement>
  noCloseButton?: boolean
  children: ReactNode
  width?: number
  height?: number
  style?: CSSProperties
}

const ModalComponent = ({ isOpen, closeModal, noCloseButton = false, children, width, height, style }: ModalProps) => {
  return (
    isOpen ? (
      <>
        <div className={styles.overlay} onClick={closeModal} />
        <div
          className={classnames(styles.modal, {
            [styles.size]: width == undefined && height == undefined,
          })}
          style={{
            width: width,
            height: height,
            ...style,
          }}
        >
          {!noCloseButton && (
            <button onClick={closeModal} className={styles.closeButton}>
              <Close
                type={"outlined"}
                style={{
                  width: "24px",
                  height: "24px",
                }}
              />
            </button>
          )}

          <div className={styles.modalMain}>{children}</div>
        </div>
      </>
    ) : null
  )
}

export default ModalComponent
